import { Injectable } from '@angular/core';

import { BaseApiService } from '~app-client/api/_internal';

export interface NodeSettingItem {
	id: string;
	subtypeId: string;
	smartFeatures: Array<{ feature: string; selectedOption: string }>;
	extractedContent: Array<{ content: string; selectedOption: string }>;
	additionalSettings: Array<{ additionalSetting: string; selectedOption: string }>;
	suggestedPropertyIds: string[];
}

@Injectable({ providedIn: 'root' })
export class NodeSettingsApiService extends BaseApiService {
	protected commonPath = ['users', 'me', 'node-subtypes-settings'];

	public async loadSettings(): Promise<NodeSettingItem[]> {
		return await this.http.get<NodeSettingItem[]>(this.url());
	}

	public async updateSettings(
		id: string,
		payload: Partial<Omit<NodeSettingItem, 'id' | 'subtypeId'>>
	): Promise<NodeSettingItem> {
		return await this.http.patch<NodeSettingItem>(this.url(id), payload);
	}
}
